export default "__VITE_PUBLIC_ASSET__420e0cf7__"